<template>
  <div class="tab-content-card">
    <!-- Módulo de Eventos -->
    <div v-if="activeTab === 'eventos'" class="tab-pane active">
      <label class="module-label">Seleccionar Evento</label>
      <div class="event-list">
        <div
          v-for="evento in proyecto.proyecto_evento"
          :key="evento.id"
          class="event-item"
          :class="{ selected: eventoSeleccionado && evento.id === eventoSeleccionado.id }"
          @click="selectEvent(evento)"
          :title="evento.evento_cultivo.nombre_evento"
        >
          <span class="event-name">
            {{ truncate(evento.evento_cultivo.nombre_evento, 30) }}
          </span>
          <font-awesome-icon
            v-if="evento.evento_finalizado"
            icon="fas fa-lock"
            class="event-locked-icon"
          />
        </div>
      </div>
      <div class="btn-group">
        <button
          class="btn btn-secondary"
          @click="emitFinalizarEvento"
          :disabled="!eventoSeleccionado || proyecto.proyecto_cerrado || eventoSeleccionado.evento_finalizado"
        >
          Finalizar Evento
        </button>
        <button
          class="btn btn-primary"
          @click="redirigirCrearEvento"
          :disabled="proyecto.proyecto_cerrado"
        >
          Crear Nuevo Evento
        </button>
      </div>
    </div>

    <div v-if="activeTab === 'cultivo'" class="tab-pane active">
      <label for="planCultivoDropdown" class="form-label">Seleccionar Plan de Cultivo</label>
      <select
        class="form-select"
        id="planCultivoDropdown"
        v-model="planSeleccionado"
        @change="emitSeleccionarVerPlan"
      >
        <option value="" disabled>Selecciona un plan</option>
        <option v-for="plan in planesDeCultivo" :key="plan.id" :value="plan">
          {{ plan.objetivo }}
        </option>
      </select>
      <button
        class="btn btn-primary"
        @click="emitUsarPlan"
        :disabled="!planSeleccionado || proyecto.proyecto_cerrado"
      >
        Trabajar con este Plan
      </button>
    </div>

    <div v-if="activeTab === 'lotes'" class="tab-pane active">
      <label for="loteDropdown" class="form-label">Seleccionar Lote</label>
      <select
        class="form-select"
        id="loteDropdown"
        v-model="loteSeleccionado"
        @change="emitSeleccionarLote"
      >
        <option value="" disabled>Selecciona un lote</option>
        <option v-for="lote in proyecto.lotes" :key="lote.id" :value="lote">
          {{ lote.nombre }}
        </option>
      </select>
      <button class="btn btn-primary" @click="redirigirCrearLote" :disabled="proyecto.proyecto_cerrado">
        Crear Nuevo Lote
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeTab: String,
    proyecto: Object,
    planesDeCultivo: Array,
  },
  data() {
    return {
      eventoSeleccionado: null,
      planSeleccionado: null,
      loteSeleccionado: null,
    };
  },
  mounted() {
    this.initializeData();
  },
  watch: {
    proyecto: {
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.initializeData();
          this.emitSeleccionarEvento();
        }
      },
      immediate: true,
    },
    'proyecto.proyecto_evento': {
          handler(eventos) {
            if (Array.isArray(eventos) && eventos.length > 0) {
              //colocar activeTab en eventos
              this.eventoSeleccionado = eventos[eventos.length - 1];
              this.eventoIdSeleccionado = this.eventoSeleccionado.id;
              this.emitSeleccionarEvento();
            } else {
              this.eventoSeleccionado = null;
              this.eventoIdSeleccionado = null;

            }
          },
          deep: true,      // necesario para detectar mutaciones internas del array
          immediate: false // no hace falta ejecutarlo en el primer render
        },
    activeTab(newValue) {
      this.initializeData();
      if (newValue === "eventos") {
        this.emitSeleccionarEvento();
      } else if (newValue === "lotes") {
        this.emitSeleccionarLote();
      } else if (newValue === "cultivo") {
        this.emitSeleccionarVerPlan();
      }
    },
  },
  methods: {
    initializeData() {
      if (Array.isArray(this.proyecto?.proyecto_evento) && this.proyecto.proyecto_evento.length > 0) {
        this.proyecto.proyecto_evento.forEach((evento) => {
          evento.fecha_inicio = this.formatoFecha(evento.fecha_inicio);
          evento.fecha_fin = this.formatoFecha(evento.fecha_fin);
        });
        this.eventoSeleccionado = { ...this.proyecto.proyecto_evento[this.proyecto.proyecto_evento.length - 1] };
      } else {
        this.eventoSeleccionado = null;
      }
      if (Array.isArray(this.proyecto?.lotes) && this.proyecto.lotes.length > 0) {
        this.loteSeleccionado = { ...this.proyecto.lotes[0] };
      } else {
        this.loteSeleccionado = null;
      }
      if (Array.isArray(this.planesDeCultivo) && this.planesDeCultivo.length > 0) {
        this.planSeleccionado =
          this.planesDeCultivo.find((plan) => plan.id === this.proyecto.plan_cultivo_id) ||
          this.planesDeCultivo[0];
      } else {
        this.planSeleccionado = null;
      }
    },
    emitSeleccionarEvento() {
        this.$store.commit("setEventoActual", this.eventoSeleccionado);
        this.$emit("seleccionar-evento", this.eventoSeleccionado);
    },
    emitFinalizarEvento() {
      this.$emit("finalizar-evento");
      //dar un F5
      location.reload();
    },
    redirigirCrearEvento() {
      this.$emit("crear-evento", this.proyecto.id);
    },
    redirigirCrearLote() {

      this.$emit("crear-lote", this.proyecto.id);
    },
    emitSeleccionarLote() {

      this.$emit("seleccionar-lote", this.loteSeleccionado);
    },
    emitSeleccionarVerPlan() {
      this.$emit("seleccionar-ver-plan", this.planSeleccionado);
    },
    emitUsarPlan() {
      this.$emit("usar-plan", this.planSeleccionado);
    },
    formatoFecha(fecha) {
      const date = new Date(fecha);
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    truncate(text, length) {
      if (text.length <= length) return text;
      return text.substring(0, length) + "...";
    },
    selectEvent(evento) {
      this.eventoSeleccionado = evento;
      this.emitSeleccionarEvento();
    },
    
  },
};


</script>

<style scoped>
.tab-content-card {
  background-color: #fff;
  padding: 0.5rem; /* Reducido para menos espacio vertical */
  border: 1px solid #ced4da;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 0.5rem; /* Reducido para menos espacio vertical */
  font-size: 0.9rem; /* Ajustado para mejor legibilidad en móviles */
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

/* Espaciado entre secciones */
.tab-pane {
  margin-bottom: 0.5rem; /* Reducido para menos espacio vertical */
}

/* Estilos de las etiquetas */
.form-label,
.module-label {
  font-size: 0.9rem; /* Ajustado para mejor legibilidad en móviles */
  margin-bottom: 0.2rem; /* Reducido para menos espacio vertical */
}

/* Lista de eventos */
.event-list {
  border: 1px solid #ced4da;
  border-radius: 8px;
  max-height: 150px; /* Reducido para menos espacio vertical */
  overflow-y: auto;
  margin-bottom: 0.4rem; /* Reducido para menos espacio vertical */
}

.event-item {
  padding: 0.2rem 0.4rem; /* Reducido para menos espacio vertical */
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
}

.event-item:hover {
  background-color: #f8f9fa;
}

.event-item.selected {
  background-color: var(--app-primary);
  color: #fff;
}

.event-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-locked-icon {
  margin-left: 0.3rem;
  color: #dc3545;
}

/* Botones personalizados para ERP */
.btn {
  font-size: 0.85rem; /* Ajustado para mejor legibilidad en móviles */
  padding: 0.4rem 0.8rem; /* Reducido para menos espacio vertical */
  border-radius: 8px;
  transition: background-color 0.3s, box-shadow 0.3s;
  box-shadow: none;
  border: none;
}

.btn-primary {
  background-color: var(--app-primary);
  color: #fff;
}

.btn-primary:hover {
  background-color: var(--app-primary-over);
}

.btn-success {
  background-color: #28a745;
  color: #fff;
}

.btn-success:hover {
  background-color: #218838;
}

.btn:disabled {
  opacity: 0.65;
  pointer-events: none;
}

/* Grupo de botones en línea */
.btn-group {
  display: flex;
  gap: 0.4rem; /* Reducido para menos espacio vertical */
}

/* Media Queries para dispositivos móviles */
@media (max-width: 768px) {
  .tab-content-card {
    padding: 0.3rem;
    font-size: 0.85rem;
  }
  .event-list {
    max-height: 120px;
  }
  .btn {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }
}
</style>
